define('views/pages/organization/users/index',['require','jquery','underscore','mediator','views/base/view','lib/utils','models/base/modal','views/base/modal','views/base/form','models/base/model','views/dialog','helpers/application','views/pages/organization/users/navbar','views/pages/organization/users/table','text!templates/pages/organization/users/index.ejs','text!templates/pages/organization/users/addUserModal.ejs','views/demo-dialog'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        mediator = require('mediator'),
        View = require('views/base/view'),
        utils = require('lib/utils'),
        ModalModel = require('models/base/modal'),
        ModalView = require('views/base/modal'),
        FormView = require('views/base/form'),
        Model = require('models/base/model'),
        Dialog = require('views/dialog'),
        applicationHelper = require('helpers/application'),
        OrganizationUsersNavbarView = require('views/pages/organization/users/navbar'),
        OrganizationUsersTableView = require('views/pages/organization/users/table'),
        template = require('text!templates/pages/organization/users/index.ejs'),
        templateAddUserModal = require('text!templates/pages/organization/users/addUserModal.ejs'),
        DemoDialog = require('views/demo-dialog');

    var AddUserModalModel = ModalModel.extend({
    });

    var AddUserContentView = FormView.extend({
        autoRender: true,
        template: templateAddUserModal
    });

    var OrganizationUsersView = View.extend({
        autoRender: true,
        template: template,
        region: 'organization-users-tab',
        regions: {
            'organization-users-table': '#organization-users-table-container',
            'organization-users-navbar': '#organization-users-navbar-container'
        },
        listen: {
            'afterLoad model': 'render',
            'activate model': 'onActivate',
            'add model': 'onAddUser',
            'edit model': 'onEditUser',
            'delete model': 'onDeleteUser'
        },

        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
        },

        render: function() {
            View.prototype.render.apply(this, arguments);

            this.subview('navbar', new OrganizationUsersNavbarView({ model: this.model }));
            this.subview('table', new OrganizationUsersTableView({ collection: this.model.users, model: this.model }));
        },

        onActivate: function() {
            mediator.setBreadcrumb(['organization'], 'Сотрудники');
            this.model.load(true);
        },

        onAddUser: function(){
            if (DemoDialog.isDemo()) { return DemoDialog.show(); }

            var buttons = [{ caption: 'Закрыть', className: '', 'action': 'cancel' }, { caption: 'Добавить', className: 'btn-success', 'action': 'add' }];

            var modalModel = new AddUserModalModel({
                title: 'Добавление нового сотрудника',
                buttons: buttons
            });

            var MModel = Model.extend({
                urlPath: '/users/add',
                validateContent: function(){
                        /*
                        fio - not null, length=100
                        nick - length=30
                        email - not null, email, length=50
                        password - not null, min length=6
                        confirmPassword - not null, equal to passwrod
                        */
                    var fio = this.get('fio'), nick = this.get('nick') || '', email = this.get('email'),
                    password = this.get('password'), confirmPassword = this.get('confirmPassword');

                    var errors = {};

                    if (!fio) {
                        errors.fio = 'Поле "Ф.И.О." не должно быть пустым';
                    } else {
                        if (fio.length > 100) { errors.fio = 'Содержимое поля "Ф.И.О." слишком большое'; }
                    }

                    if(nick.length > 30){ errors.nick = 'Поле не должно быть пустым'; }

                    if (!email) {
                        errors.email = 'Поле "E-mail" не должно быть пустым';
                    } else {
                        if(email.length > 50) {
                            errors.email = 'Содержимое поля слишком большое';
                        } else {
                            if(!utils.isEmail(email)){ errors.email = 'Неправильный формат'; }
                        }
                    }

                    if(!password){
                        errors.password = 'Поле "Пароль" не должно быть пустым';
                    } else {
                        if(password.length < 6){ errors.password = 'Пароль должен содержать минимум 6 символов'; }
                    }

                    if(confirmPassword !== password){ errors.confirmPassword = 'Пароли не совпадают'; }

                    this.set('errors', errors);


                    return _.isEmpty(errors);
                }
            });

            var modalContentModel = new MModel({
                errors: {},
                skipValidity: true,
                fio: '',
                nick: '',
                email: '',
                password: '',
                confirmPassword: ''
            });


            var _this = this;

            var modalView = new ModalView({ model: modalModel });
            var addUserContentView = new AddUserContentView({ model: modalContentModel, region: 'modal-content' });

            modalView.subview('content', addUserContentView);

            modalModel.on('action', function(action, cancel) {
                if (action === 'add') {
                    if (DemoDialog.isDemo()) { cancel(); return DemoDialog.show(); }
                    //validation
                    addUserContentView.showLoader();
                    addUserContentView.disableActions();
                    modalView.disableButtons();

                    var isValid = modalContentModel.validateContent();
                    if(isValid){
                        $('.error', addUserContentView.$el).hide();
                        modalContentModel.save().complete(function(response) {
                            if (response.status === 200) {
                                if (response.responseJSON.messages) {
                                    modalContentModel.set('errors', response.responseJSON.messages);
                                    addUserContentView.render();
                                    modalView.enableButtons();
                                } else {
                                    _this.model.load();
                                    modalView.dispose();
                                }
                            } else {
                                modalContentModel.set('errors', { global: 'Ошибка при создании записи' });
                                addUserContentView.render();
                                modalView.enableButtons();
                            }
                        });
                    } else {
                        addUserContentView.render();
                        modalView.enableButtons();
                    }

                    cancel();
                } else {
                    if (action === 'none') {
                        cancel();
                    }
                }
            });

        },

        onEditUser: function(){
            if (DemoDialog.isDemo()) { return DemoDialog.show(); }

            var selected = this.model.get('selected');

            if (!selected) {
                return;
            }

            if (selected) {
                var userId = selected.get('ID');
                applicationHelper.redirectTo('user#show', { userId: userId, page: 'details' }, { forceStartup: true });
            }
        },

        onDeleteUser: function(){
            if (DemoDialog.isDemo()) { return DemoDialog.show(); }
            //first check data , then if data is null check 'selectedUser'
            var _this = this, user;

            user = this.model.get('selected');

            if (!user) {
                return;
            }

            if (mediator.user.get('id') === user.get('ID')) {
                return Dialog.show('Удаление пользователя', 'Вы не можете удалить свою учетную запись', Dialog.Buttons.Close);
            }

            if (user) {
                var modalModel = new ModalModel({
                    'title': 'Удаление пользователя',
                    'buttons': [
                        { caption: 'Да',  className: 'btn-danger', 'action': 'submit' },
                        { caption: 'Нет', className: '', 'action': 'cancel' }
                    ],
                    body: '<h4>Вы действительно хотите удалить пользователя ' + user.get('FIO') + ' ?</h4>',
                    errors: {}
                });
                var deleteDialog = new ModalView({ model: modalModel });

                modalModel.on('action', function(action, cancel) {
                    if (action === 'submit') {
                        deleteDialog.disableButtons();

                        utils.delete('/users/remove/' + user.get('ID'))
                        .complete(function(response) {
                            if(response.status === 200){
                                if (response.responseJSON.messages) {
                                    modalModel.set('body', '<div class="alert alert-danger">Ошибка при удалении записи </div>');
                                    modalModel.set('buttons', [{ caption: 'Закрыть', className: '', 'action': 'cancel' }]);
                                    deleteDialog.render();
                                    deleteDialog.enableButtons();
                                } else {
                                    _this.model.load();
                                    deleteDialog.dispose();
                                }
                            }else{
                                modalModel.set('body', '<div class="alert alert-danger">Ошибка при удалении записи </div>');
                                modalModel.set('buttons', [{ caption: 'Закрыть', className: '', 'action': 'cancel' }]);
                                deleteDialog.render();
                                deleteDialog.enableButtons();
                            }
                        });
                        cancel();
                    }
                });
                this.subview('modal', deleteDialog);
            }
        }
    });

    return OrganizationUsersView;
});


